import React, { Suspense, lazy } from 'react';
import { NavBar } from './components/NavBar';
import { Hero } from './components/Hero';

/**
 * Pequeñas Puntadas sales page.
 * HERO → PRENDAS → BENEFICIOS → MODELO POR DENTRO → BONOS → OFERTA →
 * VOLÚMENES → PÁGINAS INTERIORES → PREGUNTAS → CIERRE → FOOTER (+ barra móvil tras la oferta).
 * Everything below the hero loads in separate chunks; each block reserves height.
 */
const named = <K extends string,>(loader: () => Promise<Record<K, React.ComponentType>>, key: K) => lazy(() => loader().then(m => ({
  default: m[key]
})));
const GallerySection = named(() => import('./components/sections/GallerySection'), 'GallerySection');
const ModelPreviewSection = named(() => import('./components/sections/ModelPreviewSection'), 'ModelPreviewSection');
const BenefitsSection = named(() => import('./components/sections/BenefitsSection'), 'BenefitsSection');
const InteriorPagesSection = named(() => import('./components/sections/InteriorPagesSection'), 'InteriorPagesSection');
const CollectionSection = named(() => import('./components/sections/CollectionSection'), 'CollectionSection');
const BonusSection = named(() => import('./components/sections/BonusSection'), 'BonusSection');
const OfferSection = named(() => import('./components/sections/OfferSection'), 'OfferSection');
const FaqSection = named(() => import('./components/sections/FaqSection'), 'FaqSection');
const FinalCta = named(() => import('./components/sections/FinalCta'), 'FinalCta');
const Footer = named(() => import('./components/Footer'), 'Footer');
const StickyBuyBar = named(() => import('./components/StickyBuyBar'), 'StickyBuyBar');
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
  id?: string;
}

/** The fallback carries the section id so anchors resolve before the chunk loads. */
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory',
  id
}: DeferredProps) {
  return <Suspense fallback={<div id={id} className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="sssq8ntq6c9v" />} data-id="element-0" data-mp="stc9c7v436ph">
      {children}
    </Suspense>;
}
export function App() {
  return <div className="app-root bg-ivory text-graphite" data-id="element-2" data-mp="3udkmtw2p4uae">
      <NavBar data-id="element-3" data-mp="3uf5hrmsxaf8s" />
      <main data-id="element-4" data-mp="d4e5zu7z1ex8">
        <Hero data-id="element-5" data-mp="d57ep0qhqei0" />
        <Deferred minHeight="900px" background="bg-blush" id="prendas" data-id="element-6" data-mp="d3mkxdc02zl7">
          <GallerySection data-id="element-7" data-mp="85uktw17c75x" />
        </Deferred>
        <Deferred minHeight="620px" data-id="element-8" data-mp="864b7kq5sgc5">
          <BenefitsSection data-id="element-9" data-mp="3gle8mfj3sxdl" />
        </Deferred>
        <Deferred minHeight="1100px" background="bg-ivory-deep" id="modelo" data-id="element-10" data-mp="3gm64lrgm4x4e">
          <ModelPreviewSection data-id="element-11" data-mp="3bmtg72a3fhzp" />
        </Deferred>
        <Deferred minHeight="800px" background="bg-blush" id="bonos" data-id="element-12" data-mp="3bk702e94zu5v">
          <BonusSection data-id="element-13" data-mp="3qbzgyuokxg9p" />
        </Deferred>
        <Deferred minHeight="900px" background="bg-ivory-deep" id="oferta" data-id="element-14" data-mp="3qd0oip6dzkmo">
          <OfferSection data-id="element-15" data-mp="3lj6bu5p785x3" />
        </Deferred>
        <Deferred minHeight="1000px" id="volumenes" data-id="element-16" data-mp="2xudatutpz7vm">
          <CollectionSection data-id="element-17" data-mp="2xt2a63vkmg8q" />
        </Deferred>
        <Deferred minHeight="900px" background="bg-paper" id="paginas" data-id="element-18" data-mp="2swbtpffutims">
          <InteriorPagesSection data-id="element-19" data-mp="18drizuto1dda" />
        </Deferred>
        <Deferred minHeight="700px" id="preguntas" data-id="element-20" data-mp="18czmmhs8vbly">
          <FaqSection data-id="element-21" data-mp="1d4hnz6y6je7g" />
        </Deferred>
        <Deferred minHeight="420px" background="bg-coral-deep" data-id="element-22" data-mp="1d59kcjzlpfys">
          <FinalCta data-id="element-23" data-mp="yfvalas44wiv" />
        </Deferred>
      </main>
      <Deferred minHeight="240px" background="bg-graphite-deep" data-id="element-24" data-mp="yh6agziftk4p">
        <Footer data-id="element-25" data-mp="13dwufxxd4zve" />
      </Deferred>

      <Suspense fallback={null} data-id="element-26" data-mp="13ey4q06k1ic2">
        <StickyBuyBar data-id="element-27" data-mp="1r4971m3jzksb" />
      </Suspense>
    </div>;
}